import { Component, OnInit ,ViewChild,ElementRef} from '@angular/core';
import { LibraryService, Dropobj } from '../../services/library.service';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { ChartType } from 'chart.js';
import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

@Component({
  selector: 'app-labvisit',
  templateUrl: './labvisit.component.html',
  styleUrls: ['./labvisit.component.scss'],
  providers:[LibraryService]
})
export class LabvisitComponent implements OnInit {

 
    memberdetails:any[]=[];
    bookdetails:any[]=[];
    issuedetails:any[]=[];
    closeResult: string;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    selitem:any={};
    selbook:any={};
    selmember:any={};
    dashcounts:any={};
    booksmodel:any={};
    objvisitcnt:any={};
     value: Date;
     isLoadingResult: boolean;
     memno:any='';
     memexist: boolean=false;
     visitorexist: boolean=false;
     fserdt:any;
     fserdt4:any;
    constructor(private http: HttpClient, private liservice: LibraryService,private modalService: NgbModal) {
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'sm'
      }
  
    //  this.fserdt=this.liservice.getdatetoday();
    //  this.fserdt4=this.liservice.getdatetoday();
   
     }
     @ViewChild('dt') dt: ElementRef;
   
     
  getdatetoday() {
    this.liservice.getsysdatetoday()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            this.fserdt = resultArray;
            this.fserdt4 = resultArray;
           // this.recdt = resultArray;
           this.getlabvisitorrecord();
        },
        error => console.log("Error :: " + error)
        )
  }
    ngOnInit(): void {
      //this.Dasheadcounts();
     
      this.getlabvisitordashcounts();
      this.getdatetoday();
     
      this.chartwalkins('chartlabdailywalkin');
    }
    keyword = 'name';
    keyword1 = 'title';
    acYears = [
      {value: 'return', viewValue: 'Return'},
      {value: 'renew', viewValue: 'Renew'},
    
    ];
    finereasons = [
      {value: 'NONE', viewValue: 'None'},
      {value: 'Latefee', viewValue: 'Latefee'},
      {value: 'Damaged', viewValue: 'Damaged'},
    
    ];
  
    barChartOptions: ChartOptions = {
      responsive: true,
    };
    barChartLabels: Label[] = [];
    barChartType: ChartType = 'bar';
    barChartLegend = true;
    barChartPlugins = [];
    walkinChartLabels: Label[] = [];
    walkinChartData: ChartDataSets[] = [
      // { data: [45, 37, 60, 70, 46, 33], label: 'Best Fruits' }
    ];
  walkinChartColors: Color[] = [
      {
        
        backgroundColor: '#F1670D',
      }
    ];
    Dasheadcounts()
    {
        this.liservice.Getdashboarddata('dashcounts')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-dashcounts',resultArray) ;
        this.dashcounts=resultArray[0];
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
   
    visitorcheckin()
    {
  
      this.liservice.labvisitorcheckin(this.memno)
      .subscribe(result => {
          console.log('ret',JSON.stringify(result));
          alert (result.message);
         // this.getallissuedbooks();
          if(result.status=='Success')
  {
   // this.memno=null;
  this.getlabvisitorrecord() ;
  this.dt.nativeElement.filterGlobal('', 'contains');
  //this.Refreshsummary();
  
  }
      });
    }
    checkin()
    {
      //alert(this.selbooktitle+'-'+this.selbookid);
      var id = 0;
      var subid = 0;
      var secid = 0;
      var retdt = '';
      var oprtype = 'checkin';
      
     
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      console.log('selbook-SAVE', this.selmember);
      //console.log('selbook-SAVE', this.selbook);
      
      var asgnmtdata = {id: id,  oprtype: oprtype,memid:this.selmember.id,memtype:this.selmember.usrtag };
      console.log('asgnmtdata-SAVE', asgnmtdata);
      this.liservice.savelibvisitorrecord(asgnmtdata)
      .subscribe(result => {
          console.log('ret',JSON.stringify(result));
          alert (result.message);
         // this.getallissuedbooks();
          if(result.status=='Success')
  {
    let localmodref=this.modalRef;
  localmodref.close();
  this.getlabvisitorrecord() ;
  //this.Refreshsummary();
  
  }
  
  
  else{
  
  
  }
       
      }, error => 
      alert('error in connection')
      
      );
    }
  
    getlabvisitordashcounts() {
      this.liservice.getlabvisitordashcounts()
          .subscribe(
          resultArray => {
              console.log('getlibsupplier', resultArray);
              this.dashcounts = resultArray[0];
             
          },
          error => console.log("Error :: " + error)
          )
    }
  
  checkout(id)
  {
    var asgnmtdata = {id: id,  oprtype: 'checkout',memid:0,memtype:'' };
    console.log('asgnmtdata-SAVE', asgnmtdata);
    this.liservice.savelabvisitorrecord(asgnmtdata)
    .subscribe(result => {
        console.log('ret',JSON.stringify(result));
        alert (result.message);
       // this.getallissuedbooks();
  this.getlabvisitorrecord() ;
  
         
    }, error => 
    alert('error in connection')
    
    );
  
  }
  
  getlabvisitorrecord() {
    this.liservice.getlabvisitorrecord(this.fserdt,this.fserdt4)
        .subscribe(
        resultArray => {
            console.log('getlabvisitorrecord', resultArray);
            this.issuedetails = resultArray;
            
            
        },
        error => console.log("Error :: " + error)
        )
  }
  
  exporthistory(oprtype){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
  
     var url=this.liservice.callurl+"export/expvisithistory.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&dtfrm="+this.fserdt+"&dtto="+this.fserdt4;
  
     window.open(url,'','_blank');
   }
  checkmember() {
    this.liservice.checkmemberrecord('checkmem',this.memno)
        .subscribe(
        resultArray => {
            console.log('checkmember', resultArray);
           if(resultArray[0].memcnt>=1)
           {
             this.memexist=true;
             this.checkvisitor();
           }
           else{
  
            this.memexist=false;
            alert("Member doesn't exists with this id");
           }
            
            
        },
        error => {console.log("Error :: " + error);
        this.memexist=false;
      }
        )
  }
  
  checkvisitor() {
    this.liservice.checklabmemberrecord('checkvis',this.memno)
        .subscribe(
        resultArray => {
            console.log('checkvisitor', resultArray);
            if(resultArray[0].memcnt>=1)
           {
             this.visitorexist=true;
           }
           else{
  
            this.visitorexist=false;
           }
            
            
        },
        error =>{ console.log("Error :: " + error);
        this.visitorexist=false;
      }
        )
  }
    onmemberselectEvent(item) {
      console.log('item',item);
      this.selmember=item;
     // this.getissueddetails();
      // do something with selected item
    }
   
    onmemberChangeSearch(sertxt) {
      debugger
      //alert('shivu');
      // fetch remote data from here
      // And reassign the 'data' which is binded to 'data' property.
      if(sertxt.query.length>=3) 
      {
      this.getmemberdetails('serchmem',sertxt.query);
      }
    }
  
    getmemberdetails(oprtype,sertxt) {
      this.liservice.getmemberdetails(oprtype,sertxt,0,0)
          .subscribe(
          resultArray => {
              console.log('members-result', resultArray);
              this.memberdetails = resultArray;
              
          },
          error => console.log("Error :: " + error)
          )
    }
  
  
  
    opencategory(content) {
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        //  size:'md'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }
  
    chartwalkins(oprtype)
    {
      
      this.liservice.Getdashboarddata(oprtype)
      .subscribe(
        
       resultArray =>{
        console.log('result-'+oprtype,resultArray) ;
        //this.clsdate=resultArray;
        var arr = [];
        var issued = [];
        var returned = [];
        for ( var i = 0; i < resultArray.length ; i++) {
          //console.log('multiarray -i',JSON.stringify(i));
           
                
                arr.push(resultArray[i].date15);
                issued.push(parseInt( resultArray[i].issued)); // 
               // returned.push(parseInt( resultArray[i].returned));
                
               
        }
        // this.lineChartData = [
        //   { data: issued, label: 'Issued', 
        //   backgroundColor: "rgba(150,150,150,50)",borderColor: "rgba(220,220,220,2)"},
        //   { data: returned, label: 'Returned',
        //   backgroundColor: "rgba(151,187,205,0.2)",
        //   borderColor: "rgba(151,187,205,1)" },
        // ];
       this.walkinChartData = [
          { data: issued, label: 'Walkins', 
         },
          
        ];
         this.walkinChartLabels = arr;
      
       
        
        
       // this.dataSource = new MatTableDataSource(resultArray);
        },
       error => console.log("Error :: " + error)
    )
    }
    
  }